<template>
  <el-dialog
    title="用户补贴"
    :visible="visible"
    :before-close="closeDialog"
    width="500px">
    <div style="text-align: center; font-size: 20px">
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="项目ID"
                          prop="name">
              {{info.projectid}}
            </el-form-item>
          </div>
          <div class="medium">
            <el-form-item label="用户ID"
                          prop="name">
              {{info.userid}}
            </el-form-item>
            <el-form-item label="所属省份"
                          prop="name">
              {{info.province_name}}
            </el-form-item>
            <el-form-item label="可用金额"
                          prop="name">
              {{info.remain_amount}}
            </el-form-item>
          </div>
          <div class="medium">
            <el-form-item label="补贴金额"
                          prop="name">
              <el-input v-model="form.allowance"></el-input>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <el-button type="primary"
                     native-type="submit">确定
          </el-button>
          <el-button @click="closeDialog">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  props: {
    visible: Boolean,
    info: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
  data () {
    return {
      id: 0,
      form: {
        allowance: '',
      },
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {
    async onSubmit () {
      this.loading = true
      let params = {allowance: this.form.allowance, ...this.info}
      await request.alert('executiveAllowanceApply', params).then((res) => {
        this.$message.success('执行补贴申请发送成功')
        this.closeDialog()
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    closeDialog () {
      this.$refs.form.resetFields()
      this.$emit('closeDialog')
    }
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/order/components/OrderAllowanceDialog.vue